export var MatchmakingAction = /*#__PURE__*/ function(MatchmakingAction) {
    MatchmakingAction[MatchmakingAction["ClickedFindGame"] = 1] = "ClickedFindGame";
    MatchmakingAction[MatchmakingAction["ClickedCancelFindGame"] = 2] = "ClickedCancelFindGame";
    return MatchmakingAction;
}({});
export const PRIMARY_MATCHMAKING_ACTIONS = [
    1,
    2
];
